export const SET_PERKS = "setPerks";

export const setPerks = (payload: any) => {
  return {
    type: SET_PERKS,
    payload,
  };
};
